/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { resto, usageAnalyticsService, userService } from '@saucelabs/sl-util-axios';

import {
  UsageAnalyticsAPIResponse,
  UsageAnalyticsConcurrencOrgResponse,
  UsageAnalyticsConcurrencTeamResponse,
  UsageAnalyticsGranularity,
} from './types';

export interface SharedAPIRequestParams {
  since?: number;
  until?: number;
}

export interface GetTeamsParams {
  limit?: number;
  offset?: number;
}

export interface Team {
  id: string;
  name?: string;
}

export interface GetTeamsResponse {
  links: {
    next: string | null;
    previous: string | null;
    first: string | null;
    last: string | null;
  };
  results: Team[];
}

export const getTeams = (params: GetTeamsParams) => (
  userService.get<GetTeamsResponse>(
    '/v1/teams/',
    { params },
  )
);

export const getOrganizationActivity = (params: SharedAPIRequestParams = {}) => (
  resto.get<UsageAnalyticsAPIResponse>('/rest/v1/activity/organization', { params })
);

export const getTeamsActivity = ({
  orgId,
  teamIds,
  ...params
}: { teamIds: string | string[]; orgId: string } & SharedAPIRequestParams) => (
  resto.get<UsageAnalyticsAPIResponse>('/rest/v1/activity/teams', {
    params: { ...params, id: teamIds, org_id: orgId },
  })
);

export const getGroupsActivity = ({
  groupIds,
  orgId,
  ...params
}: { groupIds: string | string[]; orgId: string } & SharedAPIRequestParams) => (
  resto.get<UsageAnalyticsAPIResponse>('/rest/v1/activity/groups', {
    params: { id: groupIds, org_id: orgId, params },
  })
);

export const getOrgActivity = ({ orgId, startDate, endDate, resourceType, granularity }: {
  orgId: string,
  startDate: string | number,
  endDate: string | number,
  resourceType: string,
  granularity: UsageAnalyticsGranularity,
}) => (
  usageAnalyticsService.get<UsageAnalyticsConcurrencOrgResponse>('/usage-analytics/v1/concurrency/org', {
    params: {
      org_id: orgId,
      start_date: startDate,
      end_date: endDate,
      resource_type: resourceType,
      granularity,
    },
  })
);

export const getTeamActivity = ({ orgId, startDate, endDate, teamIds, resourceType, granularity }: {
  orgId: string,
  startDate: string | number,
  endDate: string | number,
  teamIds: string[],
  resourceType: string,
  granularity: UsageAnalyticsGranularity,
}) => (
  usageAnalyticsService.get<UsageAnalyticsConcurrencTeamResponse>('/usage-analytics/v1/concurrency/teams', {
    params: {
      org_id: orgId,
      start_date: startDate,
      end_date: endDate,
      team_id: teamIds,
      resource_type: resourceType,
      granularity,
    },
  })
);
